import React, {useEffect} from "react";
import './aboutUs.css';
import {Col, Container, Image, Row} from "react-bootstrap";
import CustomButton from "../accesories/customBtn/CustomButton";
import {useNavigate} from "react-router-dom";


function AboutUs({content}) {
    const navigate = useNavigate()
    return (
        <Container className={'about-us-container'}>
            <Row className={'about-us-row'}>
                <Col sm={12} md={4} lg={5} className={'about-us-right-part'}>
                    <Image src={"/static/images/robot.gif"} alt={'about us image'}></Image>
                </Col>
                <Col sm={12} md={8} lg={7} className={'about-us-left-part'}>
                    <div className={'text-wrapper'}>
                        <h2>درباره <span>ما</span></h2>
                        <p style={{textAlign:'justify'}}>
                            {content.description}
                        </p>
                        <div>
                            <CustomButton
                                href={'/about-us'}
                                buttonClicked={()=>{navigate('/about-us')}}
                                text={'مشاهده بیشتر ...'}
                                bgColor={'rgb(29, 46, 61)'}
                                color={'#fff'}
                                height={'3rem'}/>
                        </div>
                    </div>
                </Col>
            </Row>
        </Container>
    );
}

export default AboutUs;